var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Loading'),(this.$router.currentRoute.path!=='/register' && this.$router.currentRoute.path!=='/login')?_c('Navbar'):_vm._e(),_c('v-container',{staticClass:"bg",attrs:{"fluid":""}},[_c('router-view',{attrs:{"temporary":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }